export const SENDER_ADDRESS_CREATE_ADDRESS = 'SENDER_ADDRESS_CREATE_ADDRESS'
export const SENDER_ADDRESS_DELETE_ADDRESS = 'SENDER_ADDRESS_DELETE_ADDRESS'
export const SENDER_ADDRESS_FETCH_ADDRESSES = 'SENDER_ADDRESS_FETCH_ADDRESSES'
export const SENDER_ADDRESS_FETCH_ADDRESS = 'SENDER_ADDRESS_FETCH_ADDRESS'
export const SENDER_ADDRESS_RETRIEVE_LAST_USED_ADDRESS = 'SENDER_ADDRESS_RETRIEVE_LAST_USED_ADDRESS'
export const SENDER_ADDRESS_SET_DEFAULT = 'SENDER_ADDRESS_SET_DEFAULT'
export const SENDER_ADDRESS_STORE_LAST_USED_ADDRESS = 'SENDER_ADDRESS_STORE_LAST_USED_ADDRESS'
export const SENDER_ADDRESS_UPDATE_ADDRESS = 'SENDER_ADDRESS_UPDATE_ADDRESS'
